import { LocalOffer, LoyaltyRounded } from "@mui/icons-material";

import Text from "@components/Text";
import { t } from "@i18n";
import { buildSummaryPrice, getPlanIntervalLabel } from "@checkout/lib/summary";

import './styles.scss';

// The "you are buying" card. It renders twice: inside the summary panel's footer (desktop)
// and inline right above the submit button (mobile) — the stylesheet shows one per breakpoint.
export default function PlanCard({
  plan,
  valuesRef,
  className,
}: {
  plan: any;
  valuesRef: any;
  className?: string;
}) {
  const summary = buildSummaryPrice(
    plan,
    valuesRef.current.installments,
    valuesRef.current.coupon,
  );
  const interval = getPlanIntervalLabel(plan);

  return (
    <div className={`checkout-plan-card ${className || ""}`.trim()}>
      <div className="checkout-plan-card-header">
        <div>
          <Text.subheading className="checkout-eyebrow">
            {t("checkout.summary.buying")}
          </Text.subheading>
          <Text.h2>{plan?.label || t("common.plan")}</Text.h2>
        </div>

        <div className="checkout-plan-icon">
          <LoyaltyRounded />
        </div>
      </div>

      <div className="checkout-price-block">
        {summary.showInstallments && (
          <Text.span className="checkout-price-prefix">
            {t("common.installmentPrefix", { count: summary.installments })}
          </Text.span>
        )}

        <div className="checkout-price-row">
          <Text.span className="checkout-price-amount">
            {summary.price}
          </Text.span>
          {!summary.isLifetime && (
            <Text.span contrast={6}>/ {interval}</Text.span>
          )}
        </div>

        <div className="pricing-details-row">
          {summary.showInstallments && (
            <Text.small>
              {t("common.total", { value: summary.total })}
            </Text.small>
          )}

          {summary.couponLabel && (
            <div className="checkout-coupon-chip">
              <LocalOffer fontSize="small" />
              <Text.span>{summary.couponLabel}</Text.span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
